"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon20Solid = forwardRef_1.forwardRef('ArrowALeftIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M9.165 15.679a1.25 1.25 0 1 1-1.767 1.767L2.16 12.21a3.125 3.125 0 0 1 0-4.42l5.237-5.236A1.25 1.25 0 1 1 9.165 4.32L4.737 8.75H17.5a1.25 1.25 0 1 1 0 2.5H4.737l4.428 4.429Z" })));
});
